import React from 'react';
import Button from '../../../components/ui/Button';

const SessionTypeSelector = ({ selectedType, onTypeChange }) => {
  const sessionTypes = [
    { value: 'general', label: 'General', icon: 'MessageCircle', color: 'bg-blue-500' },
    { value: 'workout_plan', label: 'Workout Plan', icon: 'Dumbbell', color: 'bg-purple-500' },
    { value: 'nutrition_advice', label: 'Nutrition', icon: 'Apple', color: 'bg-green-500' },
    { value: 'form_check', label: 'Form Check', icon: 'Eye', color: 'bg-orange-500' },
    { value: 'motivation', label: 'Motivation', icon: 'Zap', color: 'bg-red-500' }
  ];

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-foreground mb-3">
        Coaching Focus
      </label>
      <div className="flex flex-wrap gap-2">
        {sessionTypes?.map(type => (
          <Button
            key={type?.value}
            variant={selectedType === type?.value ? 'default' : 'outline'}
            size="sm"
            onClick={() => onTypeChange(type?.value)}
            iconName={type?.icon}
            iconPosition="left"
            iconSize={16}
            className="whitespace-nowrap"
          >
            {type?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SessionTypeSelector;
